<template>
  <div class="nation-picker">
    <div class="left-nation">
      <div class="city-title">{{ $t('countryOfDischarge') }}</div>
      <div class="city-name">
        <a-dropdown>
          <div>
            {{ $dt(leftPickedNation, 'CODE_NAME') }}
            <a-icon type="down"/>
          </div>
          <a-menu slot="overlay" @click="pickLeftNation">
            <a-menu-item v-for="item in leftNationOption" :key="item.CODE_ID">
              {{ $dt(item, 'CODE_NAME') }}
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
    <div class="change-icon" @click="changePosition">
      <a-icon style="color: #1F6CBA" type="swap"/>
    </div>
    <div class="right-nation">
      <div class="city-title">{{ $t('returnBoxNation') }}</div>
      <div class="city-name">
        <a-dropdown>
          <div>
            {{ $dt(rightPickedNation, 'CODE_NAME') }}
            <a-icon type="down"/>
          </div>
          <a-menu slot="overlay" @click="pickRightNation">
            <a-menu-item v-for="item in rightNationOption" :key="item.CODE_ID">
              {{ $dt(item, 'CODE_NAME') }}
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
const CHINA_NATION_ID = 10000005;
const RUS_NATION_ID = 10000006;

export default {
  name: "changeNation",
  props: {
    leftNation: {type: Number},
    rightNation: {type: Number},

    emitPickedNation: {type: Boolean, default: false},
    ignoreLocal: {type: Boolean, default: false},
  },
  data() {
    return {
      allNationList: [],
    };
  },
  computed: {
    leftNationOption(){
      return this.allNationList.filter(item => item.CODE_ID !== this.leftNation && item.CODE_ID !== this.rightNation);
    },
    rightNationOption(){
      return this.allNationList.filter(item => item.CODE_ID !== this.leftNation && item.CODE_ID !== this.rightNation);
    },
    leftPickedNation(){
      return this.allNationList.find(item => item.CODE_ID === this.leftNation) || {};
    },
    rightPickedNation(){
      return this.allNationList.find(item => item.CODE_ID === this.rightNation) || {};
    },
  },
  methods: {
    changePosition() {
      const leftNation = this.rightNation;
      const rightNation = this.leftNation;
      this.emitNation(leftNation, rightNation);

      if(!this.ignoreLocal){
        localStorage.setItem(this.$store.state.userInfo.USER_ID + 'nationSelect', `${leftNation}_${rightNation}`);
      }
    },
    getAllNationList() {
      this.$h5Api({
        type: '1001',
        data: [this.$dotNetUtil.commonQueryJson('BM_BASE_CODE', {"TYPE_ID": "10000006"}, 1, '')],
      }).then(({data}) => {
        this.allNationList = data['DATA_LIST'];

        if(this.emitPickedNation && this.pickedNation.CODE_ID){
          this.$emit('pickedNation', this.pickedNation);
        }
      });
    },
    pickLeftNation({key}) {
      const leftNation = key;
      const rightNation = this.rightNation;
      this.emitNation(leftNation, rightNation);
      if(!this.ignoreLocal){
        localStorage.setItem(this.$store.state.userInfo.USER_ID + 'nationSelect', `${leftNation}_${rightNation}`);
      }
    },
    pickRightNation({key}) {
      const leftNation = this.leftNation;
      const rightNation = key;
      this.emitNation(leftNation, rightNation);
      if(!this.ignoreLocal){
        localStorage.setItem(this.$store.state.userInfo.USER_ID + 'nationSelect', `${leftNation}_${rightNation}`);
      }
    },
    emitNation(leftNation, rightNation){
      this.$emit('getNation', leftNation, rightNation);
      if(this.emitPickedNation && this.pickedNation.CODE_ID){
        this.$nextTick(() => {
          this.$emit('pickedNation', this.pickedNation);
        })
      }
    }
  },
  created() {
    this.getAllNationList();
    if(!this.ignoreLocal){
      const localStorageStr = localStorage.getItem(this.$store.state.userInfo.USER_ID + 'nationSelect');
      if(localStorageStr){
        if(`${this.leftNation}_${this.rightNation}` !== localStorageStr){
          const localNation = localStorageStr.split('_');
          this.emitNation(Number(localNation[0]), Number(localNation[1]));
        }
      }else{
        if(!this.leftNation && !this.rightNation){
          this.emitNation(CHINA_NATION_ID, RUS_NATION_ID);
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.nation-picker {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 450px;
  height: 70px;
  border-radius: 6px;
  border: 1px solid #EEEEEE;
  padding: 10px 24px;

  .change-icon {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
    font-size: 20px;
  }

  .right-nation {
    text-align: right;
  }

  .city-title {
    font-weight: 400;
    color: #888888;
    line-height: 17px;
    margin-bottom: 4px;
  }

  .city-name {
    font-size: 18px;
    color: #484747;
    line-height: 25px;
    transition: all 1s;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    font-weight: 700;
    position: absolute;
    bottom: 10px;
    width: 40%;
  }

  .left-nation{
    .city-name{
      left: 24px;
    }
  }
  .right-nation{
    .city-name{
      left: calc(60% - 24px);
    }
  }

  &.changePosition{
    .left-nation{
      .city-name{
        left: calc(60% - 24px);
        text-align: right;
      }
    }
    .right-nation{
      .city-name{
        text-align: left;
        left: 24px;
      }
    }
  }
}
</style>
